import { SERVICES } from "../data/services";
import styles from "./About.module.css";

const SPECIALTIES = Array.from(new Set(SERVICES.map((s) => s.name))).slice(0, 6);

export function About() {
  return (
    <section id="about" className={`container-wide ${styles.section}`} aria-labelledby="about-heading">
      <div className={styles.grid}>
        <figure className={styles.media} data-reveal>
          <picture>
            <source
              type="image/avif"
              srcSet="/assets/cathryn-520.avif 1x, /assets/cathryn-1040.avif 2x"
            />
            <source
              type="image/webp"
              srcSet="/assets/cathryn-520.webp 1x, /assets/cathryn-1040.webp 2x"
            />
            <img
              src="/assets/cathryn.jpg"
              alt="Portrait of Cathryn in her Hermosa Beach studio"
              width={1040}
              height={1300}
              loading="lazy"
              decoding="async"
            />
          </picture>
          <figcaption className={`mediaBadge ${styles.mediaBadge}`}>
            <span className={`mediaBadgeDot ${styles.badgeDot}`} aria-hidden="true" />
            In studio &nbsp;/&nbsp; Hermosa Beach
          </figcaption>
        </figure>

        <div className={styles.text}>
          <p className={styles.kicker}>About Cathryn</p>
          <h2 id="about-heading" className={styles.heading}>
            A studio built for <em>considered color</em>, not high-volume turnover.
          </h2>
          <p className={styles.body}>
            Cathryn works one-on-one with every client in a private Hermosa Beach studio. Time is
            built in to listen, plan, and finish, the way editorial color is meant to be delivered.
            The result is hair that grows out beautifully, supported between visits with a plan you
            can actually run.
          </p>
          <ul className={styles.specialties} aria-label="Signature services">
            {SPECIALTIES.map((name) => (
              <li key={name} className={styles.specialty}>
                <span className={styles.specialtyName}>{name}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}